import * as React from "react";
import styled from "styled-components";
import { Heading4 } from "../../Text/Text";
import { StyledLink } from "../../Link";
import { IMenuItem } from "../IMenuItem";
import { TEXT } from "../../../consts/style";

interface Props {
  titleMenuItem: IMenuItem;
  menuItems: IMenuItem[];
}

const LinkListContainer = styled.div`
  margin: 20px;
  min-width: 200px;
`;

const LinkedListLink = styled(StyledLink)`
  line-height: 2;
  display: block;
  font-weight: 500;
  &:hover,
  &:hover h4 {
    color: ${TEXT.LINK.HOVER};
    cursor: pointer;
  }
`;

export const LinkList = ({ titleMenuItem, menuItems = [] }: Props) => (
  <LinkListContainer>
    <LinkedListLink
      href={titleMenuItem.link}
      data-id={titleMenuItem.tracking}
      componentType={"navDesktopMenuTitle"}
    >
      <Heading4>{titleMenuItem.title}</Heading4>
    </LinkedListLink>
    {menuItems.map(({ tracking, title, link }, ix) => (
      <LinkedListLink
        data-id={tracking}
        componentType={"navDesktopMenuItem"}
        href={link}
        key={`${ix}-${title}`}
      >
        {title}
      </LinkedListLink>
    ))}
  </LinkListContainer>
);
